import {Dispatch, SetStateAction} from 'react'
import {
  CustomerSubShow,
  InvoiceSubRow,
  ProductSubShow,
  stuffidFileTagSubRow,
  EbtalSubShow,
} from '../../../app/modules/apps/invoice-management/invoices-list/core/_models'

export type ID = undefined | null | number | string
export type DataStack = {
  key: string
  value: any
}

export interface IFilter {
  search?: string
  fromNo?: string
  toNo?: string
  subject?: string
  type?: string
  template?: string
  descriptionSearch?: string
  netPrice?: string
  netPriceCompare?: string
  buyerType?: string
  buyerSearch?: string
  sellerType?: string
  sellerSearch?: string
  productSearch?: string
  productType?: string
  phase?: string[]
  sendStatus?: string[]
  buyerStatus?: string[]
  StatusInquiry?: string[]
  article6Status?: string[]
  fromDate?: string
  toDate?: string
  saveFromDate?: string
  saveToDate?: string
  settlement?: string
  paymentTypes?: string[]
  fiscalMemories?: string[]
  // «روش ثبت»: Invoice.EntryType values (API نسخه ۲ = 6, فایل اکسل = 2, …).
  entryTypes?: string[]
  // '1': only the invoices totals count — no cancellation invoice, nothing cancelled.
  counted?: string
  // «نوع سند»: 'invoice' (invoices only), 'proforma' (proformas only) or empty (both).
  kind?: string
  // «وضعیت اعتبار» of proformas: open, expiring, expired, converted. Keeps proformas only.
  proformaState?: string[]
  // A proforma's last valid day, from/to (Jalali). Keeps proformas only.
  validFromDate?: string
  validToDate?: string
  // «پاسخ خریدار به لینک»: pending, approved, rejected, closed — the buyer link's answer, not the tax workspace's.
  buyerResponses?: string[]
  // «نوع خطا»: keys of api/invoices/error-reasons (code:0300101, text:<hash>). Keeps failed invoices only.
  errorReasons?: string[]
  // «جست‌وجو در متن خطا»: text or a code the failed invoice's error holds. Keeps failed invoices only.
  errorSearch?: string
}

export type PaginationState = {
  page: number
  total?: number
  filterTotal?: number
  sum?: number
  pageSum?: number
  filterSum?: number
  // A list served without counting it: no totals, and hasNextPage tells whether to go on.
  totalsOmitted?: boolean
  hasNextPage?: boolean
  items_per_page: 15 | 30 | 50 | 100 | 200
  links?: Array<{label: string; active: boolean; url: string | null; page: number | null}>
  extraData?: any
}

export type SortState = {
  sort?: string
  order?: 'asc' | 'desc'
}

export type FilterState = {
  filter?: IFilter | unknown
}

export type SearchState = {
  search?: string
}

export type Response<T> = {
  data?: T
  payload?: {
    message?: string
    errors?: {
      [key: string]: Array<string>
    }
    pagination?: PaginationState
  }
}

export type ExtraData = {
  baseMode?: number
  invoiceSeason?: string
}

export type QueryState = PaginationState & SortState & FilterState & SearchState & ExtraData

export type QueryRequestContextProps = {
  state: QueryState
  updateState: (updates: Partial<QueryState>) => void
}

export const initialQueryState: QueryState = {
  page: 1,
  items_per_page: 15,
}

export const initialQueryRequest: QueryRequestContextProps = {
  state: initialQueryState,
  updateState: () => {},
}

export type QueryResponseContextProps<T> = {
  response?: Response<Array<T>> | undefined
  refetch: () => void
  isLoading: boolean
  query: string
  /** When the list last got an answer; it changes on every refetch, even when the rows are the same. */
  dataUpdatedAt?: number
}

export const initialQueryResponse = {refetch: () => {}, isLoading: false, query: ''}

export type ListViewContextProps = {
  selected: Array<ID>
  onSelect: (selectedId: ID) => void
  onSelectAll: () => void
  clearSelected: () => void
  itemIdForUpdate?: ID
  setItemIdForUpdate: Dispatch<SetStateAction<ID>>
  variableA?: any
  setvariableA: Dispatch<SetStateAction<any>>
  variableB?: any
  setvariableB: Dispatch<SetStateAction<any>>
  variableC?: any
  setvariableC: Dispatch<SetStateAction<any>>
  variableD?: any
  setvariableD: Dispatch<SetStateAction<any>>
  shareData?: DataStack[]
  setShareData: Dispatch<SetStateAction<DataStack[]>>
  nestedOpen?: ID[]
  setNestedOpen: Dispatch<SetStateAction<ID[]>>

  invoiceNestedRows: InvoiceSubRow[]
  setInvoiceNestedRows: Dispatch<SetStateAction<InvoiceSubRow[]>>

  stuffidFileTagNestedRows: stuffidFileTagSubRow[]
  setStuffidFileTagNestedRows: Dispatch<SetStateAction<stuffidFileTagSubRow[]>>

  customerNestedRows: CustomerSubShow[]
  setCustomerNestedRows: Dispatch<SetStateAction<CustomerSubShow[]>>

  ebtalNestedRows: EbtalSubShow[]
  setEbtalNestedRows: Dispatch<SetStateAction<EbtalSubShow[]>>

  productNestedRows: ProductSubShow[]
  setProductNestedRows: Dispatch<SetStateAction<ProductSubShow[]>>

  isAllSelected: boolean
  disabled: boolean

  // The invoice list's «پیش‌فاکتور جدید»: the new-document form opens as a proforma.
  newProforma?: boolean
  setNewProforma?: Dispatch<SetStateAction<boolean>>
}

export const initialListView: ListViewContextProps = {
  selected: [],
  onSelect: () => {},
  onSelectAll: () => {},
  clearSelected: () => {},
  setItemIdForUpdate: () => {},
  setvariableA: () => {},
  setvariableB: () => {},
  setvariableC: () => {},
  setvariableD: () => {},
  setNestedOpen: () => {},
  setShareData: () => {},

  invoiceNestedRows: [],
  setInvoiceNestedRows: () => {},

  stuffidFileTagNestedRows: [],
  setStuffidFileTagNestedRows: () => {},

  customerNestedRows: [],
  setCustomerNestedRows: () => {},

  ebtalNestedRows: [],
  setEbtalNestedRows: () => {},

  productNestedRows: [],
  setProductNestedRows: () => {},

  isAllSelected: false,
  disabled: false,
}
